import React from 'react';
import { Container, Typography, Stack, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const iconVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: { delay: i * 0.2, duration: 0.5 },
  }),
};

const Contact = ({ contact }) => {
  const icons = [
    {
      icon: <GitHubIcon fontSize="large" />,
      link: contact?.github,
      label: 'GitHub',
    },
    {
      icon: <LinkedInIcon fontSize="large" />,
      link: contact?.linkedin,
      label: 'LinkedIn',
    },
    {
      icon: <InstagramIcon fontSize="large" />,
      link: contact?.instagram,
      label: 'Instagram',
    },
  ];

  return (
    <Container maxWidth="md" sx={{ my: 8, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Connect with Me
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        {icons.map((item, index) => (
          <motion.div
            key={index}
            custom={index}
            initial="hidden"
            animate="visible"
            variants={iconVariants}
          >
            <IconButton
              component="a"
              href={item.link}
              target="_blank"
              rel="noopener"
              aria-label={item.label}
              color="primary"
            >
              {item.icon}
            </IconButton>
          </motion.div>
        ))}
      </Stack>
    </Container>
  );
};

export default Contact;
